import { get } from '@vueuse/core';
import type { MaybeRef } from 'vue';
import { computed, ref } from 'vue';
import { deepCompareComputed } from '@/libraries/composables/deepCompareComputed';
import { useDynamicMarketCountSubscription } from '@/types';

export function useDynamicMarketCount(
    matchId: MaybeRef<number>,
    isLive: MaybeRef<boolean>,
    isEnabled: MaybeRef<boolean> = ref(true),
) {
    const dynamicMarketCount = ref<number | null>(null);

    const variables = computed(() => ({
        query: {
            matchId: get(matchId),
            isLive: get(isLive),
        },
    }));

    const { onSubscription } = useDynamicMarketCountSubscription(
        variables,
        deepCompareComputed(() => ({
            enabled: get(isEnabled),
        })),
    );

    onSubscription((count) => {
        if (count !== undefined) {
            dynamicMarketCount.value = count;
        }
    });

    return {
        dynamicMarketCount,
    };
}
